import _ from 'lodash';
import Selector from 'application/shared/selector';

class CanonicalCourseSelector extends Selector {
  constructor(element, options = {}) {
    super(element, {
      allowClear: true,
      courseLevel: null,
      idVal: 0,
      maximumInputLength: 256,
      minimumInputLength: 2,
      placeholder: 'Digite o curso',
      ...options,
    });
  }

  get pluginOptions() {
    const { idVal, universitiesIds } = this.options;

    return {
      ajax: {
        transport: () => {},
        data: ({ term: query }) => {
          let { courseLevel } = this.options;
          courseLevel = _.isFunction(courseLevel) ? courseLevel() : courseLevel;

          return {
            courseLevels: courseLevel && [courseLevel],
            query,
            universitiesIds,
            perPage: 15,
          };
        },
        processResults: ({ hits, nbHits: total }) => {
          const results = hits.map(({ name, objectID }) => ({
            canonical_course_id: objectID,
            id: idVal || name,
            text: name,
          }));

          return { total, results };
        },
      },
    };
  }
}

export default (...args) => new CanonicalCourseSelector(...args);
